<div *ngIf="item" style="padding: 10px 0; display: flex; align-items: center; justify-content: flex-start; gap: 10px;">
  <div>
    <mat-spinner class="spinner" [diameter]="18" mode="indeterminate"></mat-spinner>
  </div>
  <div style="flex-grow: 1;">
    <div style="font-weight: 500;">{{ item.functionName }}</div>
    <div *ngIf="!item.progress" style="font-size:13px; margin-top: 4px;">{{ item.stepsRemaining.toLocaleString() }} steps</div>
    <div *ngIf="item.progress" style="font-size:13px; margin-top: 4px;"> {{ item.progress }}% complete</div>
    <div *ngIf="item.progress">
      <mat-progress-bar mode="determinate" [value]="item.progress"></mat-progress-bar>
    </div>
  </div>
</div>

